/**
 * Creates a middleware pipeline that runs the given middleware
 * functions in sequence, while allowing each middleware to
 * terminate the pipeline by not calling `next()`.
 *
 * @param {Object} context - The context object passed to middleware
 * @param {Array<Function>} middleware - The middleware functions to run
 * @param {number} index - The index of the current middleware
 * @return {Function} - The next middleware function to run
 */
function middlewarePipeline(context, middleware, index) {
  const nextMiddleware = middleware[index];
  if (!nextMiddleware) {
    return context.next;
  }

  return (/*...parameters*/) => {
    // Run the default Vue Router `next()` callback first.
    // Context.next(...parameters);
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);

    nextMiddleware({ ...context, next: nextPipeline });
  };
}
export default middlewarePipeline;
